module.exports = __webpack_public_path__ + "img/256x256_square_partial.0e4c3333.svg";